import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * 新版本使用lottie实现动图，依赖native版本
 * 降级方案：判断qrn版本，老版本使用qrn的小骆驼动图
 */
import * as React from 'react';
import theme from '@qnpm/q-theme';
import { View, StyleSheet, Animated, Easing, Image } from 'react-native'; // import { QLoading } from 'qunar-react-native';
// import LottieView from './Lottie/LottieView';

var scale = theme.responsive.scale;
var BG_IMG = 'https://s.qunarzz.com/q_design_font/images/bgCity2x.png';
var GIF_IMG = 'https://picbed.qunarzz.com/58de9fb3be7b0d198f0f48f5a019baf4.gif';
var LOTTIE_ZIP = 'https://osd.corp.qunar.com/f_hotdog_athena_f_hotdog_athena/2020521_camel_loading_4.zip';

var Camel = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Camel, _React$PureComponent);

  var _super = _createSuper(Camel);

  function Camel(props) {
    var _this;

    _classCallCheck(this, Camel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isAnimating", void 0);

    _defineProperty(_assertThisInitialized(_this), "animateEvent", void 0);

    _this.state = {
      loadingBg: new Animated.Value(0)
    };
    _this.isAnimating = false;
    _this.animateEvent = null;
    return _this;
  }

  _createClass(Camel, [{
    key: "animateStart",
    value: function animateStart() {
      var _this2 = this;

      if (!this.isAnimating) {
        return;
      }

      this.state.loadingBg.setValue(0);
      this.animateEvent = Animated.timing(this.state.loadingBg, {
        toValue: 1,
        duration: 4000,
        easing: Easing.linear,
        useNativeDriver: true
      }).start(function () {
        return _this2.animateStart();
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isAnimating = true;
      this.animateStart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isAnimating = false;

      if (this.animateEvent) {
        this.animateEvent.stop();
        this.animateEvent = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var translateX = this.state.loadingBg.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 140]
      });
      return <View style={styles.camelWrapper}>
                <View style={styles.bgImgCon}>
                    <Animated.Image style={[styles.bgImg, {
            transform: [{
              translateX: translateX
            }]
          }]} source={{
            uri: BG_IMG
          }} />
                </View>
                <View style={styles.camelContent}>
                    <Image style={{
            height: scale(80),
            width: scale(80)
          }} source={{
            uri: GIF_IMG
          }} />
                </View>
            </View>;
    }
  }]);

  return Camel;
}(React.PureComponent);

export { Camel as default };
var styles = StyleSheet.create({
  camelWrapper: {
    width: scale(140),
    height: scale(80),
    overflow: 'hidden'
  },
  bgImg: {
    width: scale(280),
    height: scale(40),
    marginLeft: -140
  },
  bgImgCon: {
    width: scale(140),
    height: scale(40),
    marginTop: 12,
    overflow: 'hidden',
    zIndex: -1
  },
  camelContent: {
    position: 'absolute',
    zIndex: 1,
    width: scale(140),
    alignItems: 'center'
  }
});